import { Instrument, InstrumentKind } from '@/types/generated/common/types'

// Shared presentation helpers for instrument pickers in the hedge builder
// (instrument combobox + position-group multi-select).

// Funding only accrues on perps, but Bybit ships fundingInterval="0m" on dated
// futures — parse the value instead of testing presence. The "-perp" marker
// covers Deribit (no fundingInterval on the wire) and must be dash-anchored so
// instruments on the PERP token (PERPUSDT-26JUN26) don't false-positive.
export function isPerpInstrument(i: Pick<Instrument, 'symbol' | 'fundingInterval'>): boolean {
  if (parseFloat(i.fundingInterval ?? '') > 0) return true
  return i.symbol.toLowerCase().includes('-perp')
}

// Sort order: perpetuals first, then spot, then everything else.
export function instrumentRank(i: Instrument): number {
  if (isPerpInstrument(i)) return 0
  if (i.kind === InstrumentKind.INSTRUMENT_KIND_SPOT) return 1
  return 2
}

export function instrumentKindTag(i: Instrument): string {
  if (isPerpInstrument(i)) return 'PERP'
  switch (i.kind) {
    case InstrumentKind.INSTRUMENT_KIND_SPOT:
      return 'SPOT'
    case InstrumentKind.INSTRUMENT_KIND_FUTURE:
      return 'FUT'
    case InstrumentKind.INSTRUMENT_KIND_OPTION:
      return 'OPT'
    case InstrumentKind.INSTRUMENT_KIND_INDEX:
      return 'IDX'
    default:
      return ''
  }
}
